import store from "../store";

export const updateMainStore = (data) => {
	store.dispatch({
		type: "UPDATE_MAIN_STORE",
		data,
	});
};

export const chooseSettingCategory = (category) => {
	store.dispatch({
		type: "CHOOSE_SETTING_CATEGORY",
		category,
	});
};

export const updateSelectedPreset = (cueType, preset) => {
	return store.dispatch({
		type: "UPDATE_SELECTED_PRESET",
		cueType,
		preset,
	});
};

export const setSyncing = (syncing) => {
	return store.dispatch({
		type: "SYNCING",
		syncing,
	});
};

export const socketConnected = () => {
	return store.dispatch({
		type: "SOCKET_CONNECTED",
	});
};

export const socketDisconnected = () => {
	return store.dispatch({
		type: "SOCKET_DISCONNECTED",
	});
};

export const reorderCues = (projectId, draggableId, oldIndex, newIndex) => {
	return store.dispatch({
		type: "REORDER_CUE",
		projectId,
		draggableId,
		oldIndex,
		newIndex,
	});
};
